import { Box, Button, Container, Grid, Hidden, Table, TableBody, TableCell, TableContainer, TableRow, TextField, Typography } from '@mui/material';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../Redux/reducer";
import { setCivilIdAction } from "../../Redux/actions";
import { useCallback, useEffect, useMemo, useState } from "react";
import { apiURL } from "../../constants/apiUrlConstants";
import { Link, useLocation, useNavigate } from "react-router-dom";
import IdleTimerContainer from "../../components/IdleTimerContainer";
import axios, { AxiosError } from "axios";
import { setEmailStatus } from "../../utils/emailStatus";
import Loader from "../../components/Loader";
import { clearSessionStorage, getNewToken, postRequest } from '../../services/httpservice';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DealsHistory from "../Deals/DealsHistory";

// mobile view 
import useMediaQuery from "@mui/material/useMediaQuery";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CreditLimits from '../Deals/creditlimits';
import i18n from '../../i18n/i18n';
interface ApiResponse {
  iUserId: number;
  civilId: string;
  name: string;
  phoneNo: string;
  email: string;
}

const getLocalizedMessage = (message: string) => {
  const parts = message.split("/");
  if (i18n.language === "ar" && parts.length > 1) {
    return parts[1].trim();
  }
  return parts[0].trim();
};

const Profile = () => {
  const isArabic = i18n.language === "ar";
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [civilId, setLocalCivilId] = useState<string | null>(null);
  const [email, setLocalEmail] = useState<string | null>(null);
  const [emailInput, setLocalEmailInput] = useState<string | null>(null);
  const [phoneNo, setLocalPhoneNo] = useState<string | null>(null);
  const [maskedPhoneNumber, setMaskedPhoneNumber] = useState("");
  const [userName, setLocalUserName] = useState<string | null>(null);
  const civilIdStore = useSelector((state: RootState) => state.civilId);
  const mobileNoStore = useSelector((state: RootState) => state.phoneNo);
  const [isValidEmail, setIsValidEmail] = useState(true);
  const [userData, setUserData] = useState<ApiResponse | null>(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsloading] = useState<boolean>(true);
  const [toastCloseInMs, setToastCloseInMs] = useState<number>(0);
  const [activeTab, setActiveTab] = useState<"profile" | "deals"| "creditLimits">(
    (location.state as { activeTab?: "profile" | "deals" | "creditLimits" })?.activeTab || "profile"
  );
  const getUserProfileData = async () => {
    try {
      const accessToken = sessionStorage.getItem("accessToken");
      if (!accessToken) {
        clearSessionStorage();
        navigate("/");
        return;
      }
      const response = await postRequest(
        process.env.REACT_APP_API_URL + apiURL.GET_USER_PROFILE,
        {
          civilId: civilId,
        },
      );
      setIsloading(false);
      if (response === null) {
        toast.dismiss();
        toast.error(process.env.REACT_APP_ERROR_MSG);
        return;
      }
      if (response.status === 401) {
        toast.error("Session expired");
        clearSessionStorage();
        setTimeout(() => {
          navigate("/");
        }, 2000);
        return;
      }
      if (response.data === "") {
        toast.dismiss();
        toast.error(process.env.REACT_APP_ERROR_MSG);
        return;
      }


      const data = response.data;
      setUserData(data);
      setLocalUserName(data.name);
      setLocalCivilId(data.civilId);
      setLocalEmailInput(data.email);
      setLocalEmail(data.email);
      setLocalPhoneNo(data.phoneNo);
      const maskedNumber = data.phoneNo.slice(0, 3) + "****" + data.phoneNo.slice(-3);
      setMaskedPhoneNumber(maskedNumber);
      setIsloading(false);
      getNewToken();
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError;
        if (axiosError.response) {
          // console.log("Error while fetching user profile");
          if (axiosError?.response.status == 401) {
            toast.error("Session expired");
            clearSessionStorage();
            setTimeout(() => {
              navigate("/");
            }, 2000);
          } else {
            toast.error(process.env.REACT_APP_ERROR_MSG);
          }
        }
      } else {
        // console.log("Unknown error:", error);
      }
    }
  };
const isMobile = useMediaQuery("(max-width:900px)");

const [mobileView, setMobileView] = useState<
  "menu" | "profile" | "deals" |"creditLimits"
>((location.state as { activeTab?: "menu" | "profile" | "deals" | "creditLimits" })?.activeTab || "menu");
  useEffect(() => {
    const msToast = process.env.REACT_APP_TOAST_CLOSE_IN_SECONDS;
    if (msToast) {
      setToastCloseInMs(parseInt(msToast));
    }
    const accessToken = sessionStorage.getItem("accessToken");
    if (!accessToken) {
      navigate("/");
      return;
    }

    const storedCivilId = sessionStorage.getItem("civilId");
    if (storedCivilId) {
      setLocalCivilId(storedCivilId);
      dispatch(setCivilIdAction(storedCivilId));
    } else if (civilIdStore) {
      setLocalCivilId(civilIdStore);
    }

    if (civilId) {
      getUserProfileData();
    }
  }, [civilId]);

  const handleInputChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const inputValue = event.target.value;
      setLocalEmail(inputValue);
      setLocalEmailInput(inputValue);
      const emailRegex = /^[^\s@]{1,64}@[^\s@]{1,63}\.[^\s@]{2,63}$/;
      setIsValidEmail(emailRegex.test(inputValue));
    },[]
  );

  const handleSave = useCallback(async () => {
    try {
      setIsloading(true);
      const accessToken = sessionStorage.getItem("accessToken");
      if (!accessToken) {
        navigate("/");
        return;
      }
      const response = await postRequest(
        process.env.REACT_APP_API_URL + apiURL.UPDATE_EMAIL,
        {
          civilId: civilId,
          email: email,
        },
      );
      setIsloading(false);
      if (response === null) {
        toast.dismiss();
        toast.error(process.env.REACT_APP_ERROR_MSG);
        return;
      }
      if (response.data === "") {
        toast.dismiss();
        toast.error(process.env.REACT_APP_ERROR_MSG);
        return;
      }
      if (response.status === 401) {
        toast.error("Session expired");
        setTimeout(() => {
          navigate("/");
        }, 2000);
        return;
      }

      if (response != null && response != undefined) {
        if (response.data.success) {
          setEmailStatus(true);
          setLocalEmail(emailInput);
          setLocalEmailInput(email);
          toast.success(getLocalizedMessage(response.data.message));
        } else {
          toast.error(getLocalizedMessage(response.data.message));
        }
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError;
        if (axiosError.response) {
          if (axiosError?.response.status == 401) {
            toast.error("Session expired");
            clearSessionStorage();
            setTimeout(() => {
              navigate("/");
            }, 2000);
          } else {
            toast.error(process.env.REACT_APP_ERROR_MSG);
          }
        }
      }
    }
  }, [civilId, email, navigate]);

 

const getTranslateX = () => {
  const value =
    mobileView === "menu"
      ? 0
      : mobileView === "profile"
      ? 25
      : mobileView === "deals"
      ? 50
      : 75;

  return isArabic
    ? `translateX(${value}%)`
    : `translateX(-${value}%)`;
};
  return (
    <Container
      className="mainContainer"
      maxWidth="xl"
      sx={{
        mt: { xs: 24, sm: 4 },
        mb: 10,
        minWidth: "375px",
      }}
    >
      {isLoading && <Loader />}

      <Box sx={{ background: "#fff", border: "1px solid #D9D9D9" }}>
        {/* TOP HEADER */}
        {!isMobile && (
  <Box
          className="headerSubheaderStyle headerColor headerBgColor"
          sx={{
            alignItems: "center",
            px: 5,
            flexWrap: "wrap",
            gap: 2,
          }}
        >
          {/* ACCOUNT TITLE */}
          
          <Box
            className="trns-HeaderTitle"
            sx={{
              fontSize: { xs: '0.9rem', sm: '1.2rem' },
              fontWeight: 700,
            }}
          >
            {t('profile.account')}
          </Box>

          {/* LIMIT CARDS */}
          <Box
            sx={{
              display: "flex",
              gap: 2,
              flexWrap: "wrap",
              justifyContent: "center",
            }}
          >
            {/* <Box
              sx={{
                background: "#fff",
                borderRadius: "10px",
                px: "20px",
                py: "5px",
                textAlign: "center",
                minWidth: "160px",
              }}
            >
              <Typography sx={{ fontSize: "14px", color: "#060606" }}>
                {t('profile.xpayLimit')}
              </Typography>

              <Typography
                sx={{ fontWeight: 700, fontSize: "14px", color: "#060606" }}
              >
                500 KWD
              </Typography>
            </Box>

            <Box
              sx={{
                background: "#fff",
                borderRadius: "10px",
                px: "20px",
                py: "5px",
                textAlign: "center",
                minWidth: "160px",
              }}
            >
              <Typography sx={{ fontSize: "14px", color: "#060606" }}>
                {t("profile.youveUsed")}
              </Typography>

              <Typography
                sx={{ fontWeight: 700, fontSize: "14px", color: "#060606" }}
              >
                0.000 KWD
              </Typography>
            </Box>

            <Box
              sx={{
                background: "#fff",
                borderRadius: "10px",
                px: "20px",
                py: "5px",
                textAlign: "center",
                minWidth: "160px",
              }}
            >
              <Typography sx={{ fontSize: "14px", color: "#060606" }}>
                {t('profile.available')}
              </Typography>

              <Typography
                sx={{ fontWeight: 700, fontSize: "14px", color: "#060606" }}
              >
                500 KWD
              </Typography>
            </Box> */}
          </Box>

          {/* CIVIL ID */}
          {!isLoading && (
            <Box
              className="trans-civilID"
              sx={{
                fontWeight: 600,
                fontSize: "15px",
              }}
            >
            {t("profile.civilId2")} - {civilId}
            </Box>
          )}
        </Box>
        )}
{isMobile && (
  <>
    {/* ACCOUNT HEADER */}
    <Box
      sx={{
        background: "#2493C7",
        color: "#fff",
        p: 2,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        borderRadius: "4px",
        mb: 1.5,
      }}
    >
      <Typography
        sx={{
          fontWeight: 700,
          fontSize: "18px",
          textTransform: "uppercase",
        }}
        
      >
        {t("profile.account")}
      </Typography>

      {!isLoading && (
        <Typography 
          sx={{
            fontWeight: 600,
            fontSize: "15px",
      
  
          }}
        >
           {t("profile.civilId")} - {civilId}
        </Typography>
      )}
    </Box>

    {/* LIMIT CARDS */}
    <Box
      sx={{
        display: "flex",
        gap: 1,
        mb: 3,
      }}
    >
      {/* <Box
        sx={{
          flex: 1,
          border: "1px solid #D9D9D9",
          borderRadius: "10px",
          p: 1.5,
          textAlign: "center",
          background: "#fff",
        }}
      >
        <Typography fontSize="12px">
          {t("profile.xpayLimit")}
        </Typography>
        <Typography fontWeight={700} fontSize="18px">
          500 KWD
        </Typography>
      </Box>

      <Box
        sx={{
          flex: 1,
          border: "1px solid #D9D9D9",
          borderRadius: "10px",
          p: 1.5,
          textAlign: "center",
          background: "#fff",
        }}
      >
        <Typography fontSize="12px">
          {t("profile.youveUsed")}
        </Typography>
        <Typography fontWeight={700} fontSize="18px">
          0.000 KWD
        </Typography>
      </Box>

      <Box
        sx={{
          flex: 1,
          border: "1px solid #D9D9D9",
          borderRadius: "10px",
          p: 1.5,
          textAlign: "center",
          background: "#fff",
        }}
      >
        <Typography fontSize="12px">
          {t("profile.available")}
        </Typography>
        <Typography fontWeight={700} fontSize="18px">
          500 KWD
        </Typography>
      </Box> */}
    </Box>
  </>
)}
        {/* MAIN CONTENT */}
        
        {/* <Box
           sx={{
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    minHeight: { xs: "auto", md: "650px" },
    borderTop: "1px solid #DADADA",
    background: "#fff",
  }}
        >
         
          <Box
           sx={{
    width: { xs: "100%", md: "250px" },
    display: { xs: "flex", md: "block" },
    overflowX: { xs: "auto", md: "visible" },
    background: "#F3F3F3",
    borderRight: { md: "1px solid #E0E0E0" },
  }}
          >
           
            <Box
              onClick={() => setActiveTab("profile")}
              sx={{
                p: 3,
                fontWeight: 700,
                color: activeTab === "profile" ? "#2493C7" : "#000",
                background: activeTab === "profile" ? "#fff" : "transparent",
                cursor: "pointer",
              }}
            >
              {t('profile.myProfile')}
            </Box>

       
            <Box
              onClick={() => setActiveTab("deals")}
              sx={{
                p: 3,
                fontWeight: 700,
                color: activeTab === "deals" ? "#2493C7" : "#000",
                background: activeTab === "deals" ? "#fff" : "transparent",
                cursor: "pointer",
              }}
            >
              {t('profile.dealsHistory')}
            </Box>
          </Box>

          
          <Box
            sx={{
              flex: 1,
                 overflowX: "auto",
              p: { xs: 3, md: 6 },
            }}
          >
    
            {activeTab === "profile" && (
              <Grid
                sx={{
                  width: "100%",
                  maxWidth: "700px",
                  overflow: "hidden  ",
                }}
              >
                <TableContainer
                  className="profileTable"
                  sx={{
                    width: "100%",
                    maxWidth: "100%",
                    overflow: "hidden ",
                 
                  }}
                >
                  <Table size="small">
                    <TableBody>
                 
                      <TableRow>
                        <TableCell
                          sx={{
                            borderBottom: "none",
                            wordBreak: "break-word",
                            overflowWrap: "break-word",
                            whiteSpace: "normal",
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: "bold",
                              fontSize: "18px",
                              wordBreak: "break-word",
                              whiteSpace: "normal",
                            }}
                          >
                            {t('profile.name')}
                          </Typography>
                        </TableCell>

                        <TableCell sx={{ borderBottom: "none" }}>
                          <Typography sx={{ fontSize: "18px" }}>
                       
                            Fahad Al-Hamadi
                          </Typography>
                        </TableCell>
                      </TableRow>

           
                      <TableRow>
                        <TableCell sx={{ borderBottom: "none" }}>
                          <Typography
                            sx={{
                              fontWeight: "bold",
                              fontSize: "18px",
                            }}
                          >
                            {t('profile.civilId')}
                          </Typography>
                        </TableCell>

                        <TableCell sx={{ borderBottom: "none" }}>
                          <Typography sx={{ fontSize: "18px" }}>
                   
                            123456781234
                          </Typography>
                        </TableCell>
                      </TableRow>

              
                      <TableRow>
                        <TableCell sx={{ borderBottom: "none" }}>
                          <Typography
                            sx={{
                              fontWeight: "bold",
                              fontSize: "18px",
                            }}
                          >
                            {t('profile.phoneNumber')}
                          </Typography>
                        </TableCell>

                        <TableCell sx={{ borderBottom: "none" }}>
                          <Typography sx={{ fontSize: "18px" }}>
                            +965***4567 {maskedPhoneNumber}
                          </Typography>
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell sx={{ borderBottom: "none" }}>
                          <Typography
                            sx={{
                              fontWeight: "bold",
                              fontSize: "18px",
                            }}
                          >
                            {t('profile.emailId')}
                          </Typography>
                        </TableCell>

                        <TableCell sx={{ borderBottom: "none" }}>
                          <Hidden xsDown>
                            <TextField
                              className="fullWidth borderStyleEmail"
                              placeholder={t('profile.enterEmail')}
                              // value={emailInput}
                              value="Fahad123@gmail.com"
                              variant="outlined"
                              onChange={handleInputChange}
                              error={!isValidEmail}
                              fullWidth
                              // helperText={
                              //     !isValidEmail &&
                              //     'Please enter a valid email'
                              // }abcd
                              sx={{
                                maxWidth: "350px",
                                background: "#fff",
                                
         
                              }}
                            />
                          </Hidden>

                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-start",
                    ml: { xs: 0, md: "290px" }, // aligns with input column
                    mt: 2,
                  }}
                >
                  <Button
                    sx={{
                      width: "150px",
                      height: "45px",
                      fontWeight: "bold",
                      background: "#2493C7",
                                "&:hover": {
      backgroundColor: "#00365C",
      boxShadow: "none",
    },
                    }}
                    onClick={() => navigate("/home/deals")}
                    variant="contained"
                    // onClick={handleSave}
                  >
                    {t('common.update')}
                  </Button>
                </Box>
              </Grid>
            )}

            
            {activeTab === "deals" && <DealsHistory />}
          </Box>
        </Box> */}


        {/* MAIN CONTENT */}

{isMobile ? (
  <Box
    sx={{
      position: "relative",
      overflow: "hidden",
      minHeight: "600px",
      borderTop: "1px solid #DADADA",
      background: "#fff",
    }}
  >
    <Box
      sx={{
        display: "flex",
      width: "400%",
      // transform:
      // mobileView === "menu"
      //   ? "translateX(0%)"
      //   : mobileView === "profile"
      //   ? "translateX(-25%)"
      //   : mobileView === "deals"
      //   ? "translateX(-50%)"
      //   : "translateX(-75%)",
            transform: getTranslateX(),
    transition: "transform 0.35s ease-in-out",
      }}
    >
      {/* ================= MENU SCREEN ================= */}
      <Box
        sx={{
          width: "25%",
          p: 3,
        }}
      >
        <Box
          onClick={() => setMobileView("profile")}
          sx={{
            py: 2,
            px: 1,
            borderBottom: "1px solid #E0E0E0",
            fontWeight: 400,
            cursor: "pointer",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          {t("profile.myProfile")}
          <span>{">"}</span>
        </Box>

        <Box
          onClick={() => setMobileView("deals")}
          sx={{
            py: 2,
            px: 1,
            borderBottom: "1px solid #E0E0E0",
            fontWeight: 400,
            cursor: "pointer",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          {t("profile.dealsHistory")}
          <span>{">"}</span>
        </Box>
<Box
     onClick={() => setMobileView("creditLimits")}
  sx={{
    py: 2,
    px: 1,
    borderBottom: "1px solid #E0E0E0",
    fontWeight: 400,
    cursor: "pointer",
    display: "flex",
    justifyContent: "space-between",
  }}
>
  {t("profile.creditLimits")}
  <span>{">"}</span>
</Box>
      </Box>

      {/* ================= PROFILE SCREEN ================= */}
      <Box
        sx={{
          width: "25%",
          p: 3,
        }}
      >
<Box
  sx={{
    width: "100%",
    mb: 3,
    display: "flex",
    justifyContent: "flex-start",
  }}
>
  <Typography
    onClick={() => setMobileView("menu")}
    sx={{
      color: "#2493C7",
      fontSize: "16px",
      fontWeight: 600,
      cursor: "pointer",
      display: "inline-block",
      textDecoration: "underline", // 👈 key part
      textUnderlineOffset: "3px",   // optional nice spacing
    }}
  >
    {"<"} back
  </Typography>
  
</Box>

        <Grid
          sx={{
            width: "100%",
          }}
        >
          <TableContainer className="profileTable">
            <Table size="small">
              <TableBody>
                <TableRow>
                  <TableCell sx={{ borderBottom: "none" }}>
                    <Typography fontWeight="bold">
                      {t("profile.name")}
                    </Typography>
                  </TableCell>

                  <TableCell sx={{ borderBottom: "none" }}>
                    {userName}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell sx={{ borderBottom: "none" }}>
                    <Typography fontWeight="bold">
                      {t("profile.civilId")}
                    </Typography>
                  </TableCell>

                  <TableCell sx={{ borderBottom: "none" }}>
                    {civilId}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell sx={{ borderBottom: "none" }}>
                    <Typography fontWeight="bold">
                      {t("profile.phoneNumber")}
                    </Typography>
                  </TableCell>

                  <TableCell sx={{ borderBottom: "none" }}>
                     {"\u200E+" +maskedPhoneNumber}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell sx={{ borderBottom: "none" }}>
                    <Typography fontWeight="bold">
                      {t("profile.emailId")}
                    </Typography>
                  </TableCell>

                  <TableCell sx={{ borderBottom: "none" }}>
                    <TextField
                      fullWidth
                      value={emailInput || ''}
                      placeholder={t("profile.enterEmail")}
                      onChange={handleInputChange}
                      error={!isValidEmail}
                    />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>

          <Box sx={{ mt: 3 }}>
            <Button
              variant="contained"
              onClick={handleSave}
              sx={{
                width: "150px",
                height: "45px",
                fontWeight: "bold",
                background: "#2493C7",
                "&:hover": {
                  backgroundColor: "#00365C",
                },
              }}
            >
              {t("common.update")}
            </Button>
          </Box>
        </Grid>
      </Box>

      {/* ================= DEALS SCREEN ================= */}
      <Box
        sx={{
          width: "25%",
          p: 3,
        }}
      >
   <Box
  sx={{
    width: "100%",
    mb: 3,
    display: "flex",
    justifyContent: "flex-start",
  }}
>
  <Typography
    onClick={() => setMobileView("menu")}
    sx={{
      color: "#2493C7",
      fontSize: "16px",
      fontWeight: 600,
      cursor: "pointer",
      display: "inline-block",
      textDecoration: "underline", // 👈 key part
      textUnderlineOffset: "3px",   // optional nice spacing
    }}
  >
    {"<"} back
  </Typography>
</Box>

        <DealsHistory />
      </Box>
      {/* ================= CREDIT LIMITS SCREEN ================= */}
<Box
  sx={{
    width: "25%",
    p: 3,
  }}
>
  <Box
    sx={{
      width: "100%",
      mb: 3,
      display: "flex",
      justifyContent: "flex-start",
    }}
  >
    <Typography
      onClick={() => setMobileView("menu")}
      sx={{
        color: "#2493C7",
        fontSize: "16px",
        fontWeight: 600,
        cursor: "pointer",
        textDecoration: "underline",
      }}
    >
      {"<"} back
    </Typography>
  </Box>

  <CreditLimits />
</Box>
    </Box>
  </Box>
) : (
  /* ================= DESKTOP VIEW ================= */

  <Box
    sx={{
      display: "flex",
      flexDirection: "row",
      minHeight: "650px",
      borderTop: "1px solid #DADADA",
      background: "#fff",
    }}
  >
    {/* LEFT SIDEBAR */}
    <Box
      sx={{
        width: "250px",
        background: "#F3F3F3",
        borderRight: "1px solid #E0E0E0",
      }}
    >
      <Box
        onClick={() => setActiveTab("profile")}
        sx={{
          p: 3,
          fontWeight: 400,
          color: activeTab === "profile" ? "#2493C7" : "#000",
          background:
            activeTab === "profile" ? "#fff" : "transparent",
          cursor: "pointer",
        }}
      >
        {t("profile.myProfile")}
      </Box>

      <Box
        onClick={() => setActiveTab("deals")}
        sx={{
          p: 3,
          fontWeight: 400,
          color: activeTab === "deals" ? "#2493C7" : "#000",
          background:
            activeTab === "deals" ? "#fff" : "transparent",
          cursor: "pointer",
        }}
      >
        {t("profile.dealsHistory")}
      </Box>
<Box
  onClick={() => setActiveTab("creditLimits")}
  sx={{
    p: 3,
    fontWeight: 400,
    color: activeTab === "creditLimits" ? "#2493C7" : "#000",
    background: activeTab === "creditLimits" ? "#fff" : "transparent",
    cursor: "pointer",
  }}
>
  {t("profile.creditLimits")}
</Box>
    </Box>

    {/* RIGHT CONTENT */}
    <Box
      sx={{
        flex: 1,
        overflowX: "auto",
        p: 6,
      }}
    >
      {activeTab === "profile" && (
        <Grid
                sx={{
                  width: "100%",
                  maxWidth: "700px",
                  overflow: "hidden  ",
                }}
              >
                <TableContainer
                  className="profileTable"
                  sx={{
                    width: "100%",
                    maxWidth: "100%",
                    overflow: "hidden ",
                 
                  }}
                >
                  <Table size="small">
                    <TableBody>
                      {/* NAME */}
                      <TableRow>
                        <TableCell
                          sx={{
                            borderBottom: "none",
                            wordBreak: "break-word",
                            overflowWrap: "break-word",
                            whiteSpace: "normal",
                            textAlign: isArabic ? "right" : "left",
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: "bold",
                              fontSize: "16px",
                              wordBreak: "break-word",
                              whiteSpace: "normal",
                            }}
                          >
                            {t('profile.name')}
                          </Typography>
                        </TableCell>

                        <TableCell sx={{ borderBottom: "none", textAlign: isArabic ? "right" : "left" }}>
                          <Typography sx={{ fontSize: "16px" }}>
                            {/* {userName} */}
                              {userName}
                          </Typography>
                        </TableCell>
                      </TableRow>

                      {/* CIVIL ID */}
                      <TableRow>
                        <TableCell sx={{ borderBottom: "none", textAlign: isArabic ? "right" : "left" }}>
                          <Typography
                            sx={{
                              fontWeight: "bold",
                              fontSize: "16px",
                            }}
                          >
                            {t('profile.civilId')}
                          </Typography>
                        </TableCell>

                        <TableCell sx={{ borderBottom: "none", textAlign: isArabic ? "right" : "left" }}>
                          <Typography sx={{ fontSize: "16px" }}>
                            {/* {civilId} */}
                              {civilId}
                          </Typography>
                        </TableCell>
                      </TableRow>

                      {/* PHONE NUMBER */}
                      <TableRow>
                        <TableCell sx={{ borderBottom: "none", textAlign: isArabic ? "right" : "left" }}>
                          <Typography
                            sx={{
                              fontWeight: "bold",
                              fontSize: "16px",
                            }}
                          >
                            {t('profile.phoneNumber')}
                          </Typography>
                        </TableCell>

                        <TableCell sx={{ borderBottom: "none", textAlign: isArabic ? "right" : "left" }}>
                          <Typography sx={{ fontSize: "16px" }}>
                             {"\u200E+" +maskedPhoneNumber}
                          </Typography>
                        </TableCell>
                      </TableRow>

                      {/* EMAIL */}
                      <TableRow>
                        <TableCell sx={{ borderBottom: "none", textAlign: isArabic ? "right" : "left" }}>
                          <Typography
                            sx={{
                              fontWeight: "bold",
                              fontSize: "16px",
                            }}
                          >
                            {t('profile.emailId')}
                          </Typography>
                        </TableCell>

                        <TableCell sx={{ borderBottom: "none", textAlign: isArabic ? "right" : "left" }}>
                          <Hidden xsDown>
                            <TextField
                              className="fullWidth borderStyleEmail"
                              placeholder={t('profile.enterEmail')}
                             value={emailInput}

                              variant="outlined"
                              onChange={handleInputChange}
                              error={!isValidEmail}
                              fullWidth
                              helperText={
                                  !isValidEmail &&
                                  t('profile.invalidEmail')
                              }
                              inputProps={{ style: { textAlign: isArabic ? "right" : "left" } }}
                              sx={{
                                maxWidth: "350px",
                                background: "#fff",
                              }}
                            />
                          </Hidden>
                        </TableCell>
                      </TableRow>

                      {/* UPDATE BUTTON */}
                      <TableRow>
                        <TableCell sx={{ borderBottom: "none" }} />
                        <TableCell sx={{ borderBottom: "none", textAlign: isArabic ? "right" : "left" }}>
                          <Box sx={{ mt: 2 }}>
                            <Button
                              sx={{
                                fontSize: "14px",
                                fontWeight: "bold",
                                padding: "6px 16px",
                                background: "#2493C7",
                                "&:hover": {
                                  background: "#2493C7",
                                },
                              }}
                              onClick={handleSave}
                              variant="contained"
                            >
                              {t('common.update')}
                            </Button>
                          </Box>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
      )}

      {activeTab === "deals" && <DealsHistory />}
      {activeTab === "creditLimits" && <CreditLimits />}
    </Box>
  </Box>
)}
      </Box>

      <ToastContainer
        position="top-right"
        newestOnTop
        limit={1}
        autoClose={toastCloseInMs}
      />

      <IdleTimerContainer />
    </Container>
  );
};
export default Profile;
